// Lightweight play-event tracker for the My Worship Mix feature.
//
// We POST one event to /api/plays/track when a track starts. To avoid
// spamming the backend on every pause/resume we keep an in-memory
// Set of "bucket:track_id" pairs already logged this session.
//
// The backend has its own 90-second server-side dedupe as a safety net,
// but doing this client-side as well keeps the request count down to
// roughly one per actual song the user listens to.

import api from "./api";
import { getAuthToken } from "./api";

const SESSION_LOGGED = new Set();

export function trackPlay(bucket, item) {
  // Anonymous users get no personalization, no events.
  if (!getAuthToken()) return;
  if (!bucket || !item || !item.id) return;
  const key = `${bucket}:${item.id}`;
  if (SESSION_LOGGED.has(key)) return;
  SESSION_LOGGED.add(key);
  api
    .post("/plays/track", {
      bucket,
      track_id: item.id,
      artist: item.artist || item.preacher || item.teacher || "",
      title: item.title || "",
    })
    .catch(() => {
      // If the call fails, un-cache so we'll retry on the next play.
      SESSION_LOGGED.delete(key);
    });
}
